import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";
import { RepoUpdateInput } from "types/generated";

import { UPDATE_SPACELIFT_VCS_REPO } from "./gql";
import { SEARCH_SPACELIFT_VCS_REPOS } from "../useSpaceliftVcsReposList/gql";

const useUpdateSpaceliftVcsRepoMutation = createDefaultMutationHook(UPDATE_SPACELIFT_VCS_REPO);

const useUpdateSpaceliftVcsRepo = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [mutation, { loading }] = useUpdateSpaceliftVcsRepoMutation({
    refetchQueries: [SEARCH_SPACELIFT_VCS_REPOS],
  });

  const updateSpaceliftVcsRepo = useCallback(
    (id: string, input: RepoUpdateInput, onSuccess?: () => void) => {
      mutation({ id, input }, (data) => {
        if (data?.repoUpdate) {
          reportSuccess({ message: "Repo updated successfully" });
          onSuccess?.();
        }
      });
    },
    [mutation, reportSuccess]
  );

  return {
    updateSpaceliftVcsRepo,
    loading,
  };
};

export default useUpdateSpaceliftVcsRepo;
